import { render, staticRenderFns } from "./InventoryLists.vue?vue&type=template&id=6676d638&"
import script from "./InventoryLists.vue?vue&type=script&lang=js&"
export * from "./InventoryLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports